import type { ReactNode } from "react";
import { useTabsAutoplay } from "../hooks";
import type { TabTitleType, TabsPayload } from "../types";

export const TabsAutoplay = ({
  children,
  settings,
  titles,
  id,
  isMobile,
}: {
  children: ReactNode;
  settings: TabsPayload;
  titles: TabTitleType[];
  id: string;
  isMobile: boolean;
}) => {
  useTabsAutoplay({ settings, titles, id, isMobile });
  return <>{children}</>;
};
